import {t as n, r as o} from '@theme/global';
import '@theme/request-idle-callback';
class c extends HTMLElement {
  constructor() {
    super(),
      (this.notification = document.getElementById('cart-notification')),
      (this.header = document.querySelector('sticky-header')),
      (this.onBodyClick = this.handleBodyClick.bind(this)),
      this.notification.addEventListener('keyup', (t) => t.code === 'Escape' && this.close()),
      this.querySelectorAll('button[type="button"]').forEach((t) => t.addEventListener('click', this.close.bind(this)));
  }
  open() {
    this.notification.classList.add('animate', 'active'),
      this.notification.addEventListener(
        'transitionend',
        () => {
          this.notification.focus(), n(this.notification);
        },
        {once: !0}
      ),
      document.body.addEventListener('click', this.onBodyClick);
  }
  close() {
    this.notification.classList.remove('active'),
      document.body.removeEventListener('click', this.onBodyClick),
      o(this.activeElement);
  }
  renderContents(t) {
    (this.productId = t.id),
      this.getSectionsToRender().forEach((e) => {
        document.getElementById(e.id).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector);
      }),
      this.header && this.header.reveal(),
      this.open();
  }
  getSectionsToRender() {
    return [
      {id: 'cart-notification-product', selector: `#cart-notification-product-${this.productId}`},
      {id: 'cart-notification-button'},
      {id: 'cart-icon-bubble'},
    ];
  }
  getSectionInnerHTML(t, e = '.shopify-section') {
    return new DOMParser().parseFromString(t, 'text/html').querySelector(e).innerHTML;
  }
  handleBodyClick(t) {
    const e = t.target;
    if (e !== this.notification && !e.closest('cart-notification')) {
      const i = e.closest('details-disclosure');
      (this.activeElement = i ? i.querySelector('summary') : null), this.close();
    }
  }
  setActiveElement(t) {
    this.activeElement = t;
  }
}
customElements.get('cart-notification') || customElements.define('cart-notification', c);
